import _extends from "@babel/runtime/helpers/extends";
import React from "react";
import PropTypes from "prop-types";
import { Body as CoreBody } from "@vds-core/typography";
var propTypes = {
  /**
   * Size of the typescale that will be used.
   */
  size: PropTypes.oneOf(["small", "large"]),

  /**
   * The color of the text.
   */
  color: PropTypes.oneOf(["#000000", "#FFFFFF", "#ffffff", "#EE0000", "#ee0000", "#F6F6F6", "#f6f6f6", "#D8DADA", "#d8dada", "#A7A7A7", "#a7a7a7", "#6F7171", "#6f7171", "#333333", "#1B1D1F", "#1b1d1f", "#FBE4D7", "#fbe4d7", "#ED7000", "#ed7000", "#C44904", "#c44904", "#4A1C02", "#4a1c02", "#FFF4E0", "#fff4e0", "#FFBC3D", "#ffbc3d", "#523C14", "#523c14", "#D6EEFB", "#d6eefb", "#0096E4", "#0096e4", "#0077B4", "#0077b4", "#002B42", "#002b42", "#D6F2E0", "#d6f2e0", "#00AC3E", "#00ac3e", "#008330", "#003614", "#747676" // BRand1.0 Coolgray6
  ])
};
var defaultProps = {
  size: "small",
  color: "#000000"
};

var Body = function Body(props) {
  var size = props.size;
  return /*#__PURE__*/React.createElement(CoreBody, _extends({}, props, {
    size: size === "small" || size === "large" ? size : "small"
  }));
};

Body.propTypes = propTypes;
Body.defaultProps = defaultProps;
export default Body;